'use client';

import React from 'react';

import { PortalRecovery } from './components/PortalRecovery';

interface IErrorBoundaryProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const ErrorBoundary = ({ error, reset }: IErrorBoundaryProps): React.ReactElement => (
  <PortalRecovery source="route-error" onRetry={reset} error={error} />
);

export default ErrorBoundary;
